import * as pslip4x6PdfIcon from '~/assets/icons/print-format/slip_pdf_4x6.svg';
import * as pslip4x8PdfIcon from '~/assets/icons/print-format/slip_pdf_4x8.svg';
import * as pslip8x11PdfIcon from '~/assets/icons/print-format/slip_pdf_8x11.svg';
import * as pslip4x6PngIcon from '~/assets/icons/print-format/slip_png_4x6.svg';
import * as pslip4x8PngIcon from '~/assets/icons/print-format/slip_png_4x8.svg';
import * as pslip4x6ZplIcon from '~/assets/icons/print-format/slip_zplii_4x6.svg';
import * as pslip4x8ZplIcon from '~/assets/icons/print-format/slip_zplii_4x8.svg';

enum PackingSlipFormat {
  PSLIP_8X11_PDF = 'PDF',
  PSLIP_4X6_PDF = 'PDF_4X6',
  PSLIP_4X6_PNG = 'PNG_4x6',
  PSLIP_4X6_ZPLII = 'ZPLII_4x6',
  PSLIP_4X8_PDF = 'PDF_4X8',
  PSLIP_4X8_PNG = 'PNG_4x8',
  PSLIP_4X8_ZPLII = 'ZPLII_4x8',
}

const DefaultPackingSlipFormat: PackingSlipFormat = PackingSlipFormat.PSLIP_8X11_PDF;

const PacklingSlipFormatIcons: HashMap<PackingSlipFormat, string> = {
  [PackingSlipFormat.PSLIP_8X11_PDF]: pslip8x11PdfIcon,
  [PackingSlipFormat.PSLIP_4X6_PDF]: pslip4x6PdfIcon,
  [PackingSlipFormat.PSLIP_4X6_PNG]: pslip4x6PngIcon,
  [PackingSlipFormat.PSLIP_4X6_ZPLII]: pslip4x6ZplIcon,
  [PackingSlipFormat.PSLIP_4X8_PDF]: pslip4x8PdfIcon,
  [PackingSlipFormat.PSLIP_4X8_ZPLII]: pslip4x8ZplIcon,
  [PackingSlipFormat.PSLIP_4X8_PNG]: pslip4x8PngIcon,
};

export { PacklingSlipFormatIcons, DefaultPackingSlipFormat };

export default PackingSlipFormat;
